import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import ProgressCard from '../../../../components/card/ProgressCard'
import CartographyPanel from '../../../../components/map/CartographyPanel'
import TaxonAction from '../actions/TaxonAction'
import { useParams } from 'react-router'
import useBoolean from 'utils/customHook/useBoolean'
import useTitle from 'utils/customHook/useTitle'
import { PATH_REFERENCIAL, PATH_REFERENCIAL_TAXON, PATH_REFERENCIAL_TAXON_LINK } from 'home/constants/RouteConstants'

const TaxonCarto = () => {
    const dispatch = useDispatch()
    const { code } = useParams()

    const {
        taxon,
        qualitometersByTaxon,
        qualitometers,
    } = useSelector(store => ({
        taxon: store.TaxonReducer.taxon,
        qualitometersByTaxon: store.TaxonReducer.qualitometers,
        qualitometers: store.QualityReducer.qualitometersLight,
    }), shallowEqual)

    const {
        value: isLoading,
        setTrue: onLoadStart,
        setFalse: onLoadEnd,
    } = useBoolean(true)
    const [progress, setProgress] = useState(0)


    useTitle(() => [
        {
            title: i18n.referencials,
            href: PATH_REFERENCIAL,
        },
        {
            title: i18n.taxons,
            href: PATH_REFERENCIAL_TAXON,
        },
        {
            title: code + (taxon.latinName ? ` - ${taxon.latinName}` : ''),
            href: PATH_REFERENCIAL_TAXON_LINK + code,
        },
        {
            title: i18n.map,
            href: `${PATH_REFERENCIAL_TAXON}/${code}/map`,
        },
    ], [code, taxon])


    useEffect(() => {
        if (!taxon.length) {
            dispatch(TaxonAction.fetchTaxons())
        }
        if (code !== 'new') {
            dispatch(TaxonAction.fetchTaxon(code))
        }
    }, [dispatch, code])

    useEffect(() => {
        if (qualitometers.length === 0) return

        onLoadStart()
        const codeQualito = qualitometers.map(s => s.id)
        dispatch(TaxonAction.fetchQualitometersByTaxon(code, codeQualito, setProgress)).finally(onLoadEnd)
    }, [qualitometers, code])

    return (
        <>
            {isLoading && (<ProgressCard progress={progress} />)}
            {!isLoading && (
                <CartographyPanel
                    layers={['STATIONS_POINTS']}
                    stationsPoints={qualitometersByTaxon}
                    stationsPanelTitle={i18n.stations}
                    componentType={'quality'}
                    colorMode
                />
            )}
        </>
    )
}

export default TaxonCarto